import { render, staticRenderFns } from "./ReferralProgramOwners.vue?vue&type=template&id=d8637712&scoped=true&"
import script from "./ReferralProgramOwners.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramOwners.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgramOwners.vue?vue&type=style&index=0&id=d8637712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8637712",
  null
  
)

export default component.exports